import React from 'react';
import { AlertOverlay, AlertBox, AlertHeader, AlertLogo, AlertTitle, AlertMessage, AlertButton } from './style';

const CustomAlert = ({ message, title = 'Terserah', onClose, type = 'info' }) => {
  return (
    <AlertOverlay onClick={onClose}>
      <AlertBox onClick={(e) => e.stopPropagation()} type={type}>
        <AlertHeader>
          <AlertLogo src="/logo192.png" alt="Terserah" />
          <AlertTitle>{title}</AlertTitle>
        </AlertHeader>
        <AlertMessage>{message}</AlertMessage>
        <AlertButton onClick={onClose} type={type}>
          OK
        </AlertButton>
      </AlertBox>
    </AlertOverlay>
  );
};

export default CustomAlert;
